import { render, staticRenderFns } from "./rt-amount.vue?vue&type=template&id=78504105&"
import script from "./rt-amount.vue?vue&type=script&lang=js&"
export * from "./rt-amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports